export const cityOptions = [
  { id: "", name: "Select a city" },
  { id: "220", name: "Milan" },
  { id: "68", name: "Vienna" },
  { id: "314", name: "Verona" },
  { id: "463", name: "Venice" },
  { id: "51", name: "Paris" },
  { id: "17", name: "London" },
  { id: "13", name: "Glyndebourne" },
  { id: "180", name: "Berlin" },
  { id: "189", name: "Munich" },
  { id: "175", name: "Barcelona" },
  { id: "1130", name: "Bayreuth" },
  { id: "1116", name: "Monte-Carlo" },
  { id: "32", name: "New York" },
  { id: "181", name: "Prague" },
  { id: "495", name: "Naples" },
  { id: "653", name: "Rome" },
];

export const venueOptionsByCity = {
  "": [{ id: "", name: "Select a venue" }],
  220: [
    { id: "", name: "Select a venue" },
    { id: "247", name: "Teatro alla Scala" },
  ],
  68: [
    { id: "", name: "Select a venue" },
    { id: "8215", name: "Wiener Musikverein" },
    { id: "292", name: "Vienna State Opera" },
  ],
  314: [
    { id: "", name: "Select a venue" },
    { id: "372", name: "Arena of Verona" },
  ],
  463: [
    { id: "", name: "Select a venue" },
    { id: "750", name: "Gran Teatro La Fenice" },
  ],
  51: [
    { id: "", name: "Select a venue" },
    { id: "289", name: "Opéra Bastille" },
    { id: "288", name: "Opéra Garnier" },
    { id: "203", name: "Théâtre des Champs-Elysées" },
  ],
  17: [
    { id: "", name: "Select a venue" },
    { id: "62", name: "Royal Opera House" },
    { id: "9", name: "Royal Albert Hall" },
  ],
  13: [
    { id: "", name: "Select a venue" },
    { id: "36", name: "Glyndebourne Opera House" },
  ],
  180: [
    { id: "", name: "Select a venue" },
    { id: "758", name: "Forest Stage" },
    { id: "353", name: "State Opera Unter den Linden" },
  ],
  189: [
    { id: "", name: "Select a venue" },
    { id: "1927", name: "Bavarian State Opera" },
  ],
  175: [
    { id: "", name: "Select a venue" },
    { id: "17131", name: "Gran Teatro de Liceu" },
  ],
  1130: [
    { id: "", name: "Select a venue" },
    { id: "3652", name: "Bayreuth Festival" },
  ],
  1116: [
    { id: "", name: "Select a venue" },
    { id: "2316", name: "Opéra de Monte-Carlo" },
  ],
  32: [
    { id: "", name: "Select a venue" },
    { id: "315", name: "Metropolitan Opera" },
  ],
  181: [
    { id: "", name: "Select a venue" },
    { id: "373", name: "State Opera" },
  ],
  495: [
    { id: "", name: "Select a venue" },
    { id: "630", name: "Teatro San Carlo" },
  ],
  653: [
    { id: "", name: "Select a venue" },
    { id: "1570", name: "Teatro dell'Opera" },
  ],
};
